// extracted by mini-css-extract-plugin
export default {"host":"PageHeader_host__+6WxE"};